export default "__VITE_ASSET__Zmvx6l2K__"